import { Delete, Get, getAPIUrl, Post, Put } from "../../apiMethods";

export const staffEndpoint = {
  fetchTable: "restaurant/table/fetch-tables",
  createTable: "restaurant/table/create-table",
  updateTable: "restaurant/table/update-table",
  createQrImage: "restaurant/qr/create",
  fetchQrImage: "restaurant/qr/fetch-image",
  deleteTable: "restaurant/table/delete/",
};
const isCustomerRoute = () => {
  const path = window.location.pathname || "";
  const hash = window.location.hash || "";
  return (
    path.includes("customer") ||
    hash.includes("/single-or-group") ||
    hash.includes("/order-by-customer") ||
    hash.includes("/customer/")
  );
};
export const fetchTable = (param = "") => {
  const url = getAPIUrl(
    isCustomerRoute()
      ? "restaurant/customer/fetch-tables"
      : staffEndpoint.fetchTable,
    param
  );
  return Get(url);
};

export const createTable = (data, param = "") => {
  const url = getAPIUrl(staffEndpoint.createTable, param);
  return Post(url, data);
};
export const updateTable = (data, param = "") => {
  const url = getAPIUrl(staffEndpoint.updateTable, param);
  return Put(url, data);
};
export const deleteTable = (data, param = "") => {
  const url = getAPIUrl(staffEndpoint.deleteTable, param);
  return Delete(url, data);
};
export const createQrImage = (data, param = "") => {
  const url = getAPIUrl(staffEndpoint.createQrImage, param);
  return Post(url, data);
};
export const getQrIamge = (param = "") => {
  const url = getAPIUrl(staffEndpoint.fetchQrImage, param);
  return Get(url);
};
